import { render, staticRenderFns } from "./FederationControl.vue?vue&type=template&id=62724138&scoped=true"
import script from "./FederationControl.vue?vue&type=script&lang=js"
export * from "./FederationControl.vue?vue&type=script&lang=js"
import style0 from "./FederationControl.vue?vue&type=style&index=0&id=62724138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62724138",
  null
  
)

export default component.exports